<template>
  <div class="userList">
    <searchBar :formItems="formItems" @search="search" />
    <div style="margin-bottom: 10px">
      <el-button type="primary" @click="add()">
        <i class="el-icon-plus" />新增
      </el-button>
    </div>
    <div class="tableBox">
      <el-table
        :data="tableData"
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{ textAlign: 'center' }"
        border
        style="width: 100%"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="80"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="headUrl" label="头像" width="100">
          <template slot-scope="scope">
            <img style="width: 50px;height: 50px;border-radius: 100%;" :src="scope.row.headUrl || require('@/assets/images/1.png')" alt="">
          </template></el-table-column
        >
        <el-table-column
          prop="nickName"
          label="微信名"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="openid"
          label="openId"
          width="150"
        ></el-table-column>
        <el-table-column prop="sex" label="性别" width="80">
          <template slot-scope="scope">{{ scope.row.sex | sex }}</template>
        </el-table-column>
        <el-table-column
          prop="realName"
          label="真实姓名"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="160"
        ></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">{{
            scope.row.createTime | formatTime("YMDHMS")
          }}</template>
        </el-table-column>
        <el-table-column prop="dtxAccount" label="待提现金额"></el-table-column>
        <el-table-column prop="account" label="可提现金额"></el-table-column>
        <el-table-column
          prop="yqrName"
          label="邀请人"
          width="120"
        ></el-table-column>
        <el-table-column prop="remark" label="简介"></el-table-column>
        <el-table-column prop label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editData(scope.row)"
              >编辑</el-button
            >
            <el-button @click="deleteData(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fenye">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.page"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <UserDialog ref="dialog" @search="initPage" />
  </div>
</template>

<script>
import searchBar from "@/components/SearchBar/index";
import UserDialog from "./components/dialog.vue";
export default {
  components: { searchBar, UserDialog },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 10,
      },
      params: {},
      total: 0,
      tableData: [],
      formItems: [
        {
          label: "",
          type: "el-select",
          fieldName: "sex",
          data: [
            { label: "男", value: 0 },
            { label: "女", value: 1 },
          ],
          attrs: {
            placeholder: "性别",
          },
        },
        {
          label: "",
          type: "el-input",
          fieldName: "nickName",
          attrs: {
            placeholder: "微信名",
          },
        },
        {
          label: "",
          type: "el-input",
          fieldName: "realName",
          attrs: {
            placeholder: "真实名称",
          },
        },
        {
          label: "",
          type: "el-input",
          fieldName: "phone",
          attrs: {
            placeholder: "手机号码",
          },
        },
      ],
    };
  },
  methods: {
    indexMethod(index) {
      return index + 1 + (this.page.page - 1) * this.page.pageSize;
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.initPage();
    },
    handleCurrentChange(page) {
      this.page.page = page;
      this.initPage();
    },
    search(opt) {
      //搜索
      this.page.page = 1;
      this.params = opt;
      this.initPage();
    },
    initPage() {
      this.getAjax(
        "api/userList",
        { ...this.params, ...this.page },
        "get"
      ).then((res) => {
        res.data.list.records.forEach(e=>{
          e.account = (parseFloat(e.account) / 100).toFixed(2);
          e.dtxAccount = (parseFloat(e.dtxAccount) / 100).toFixed(2);
        })
        this.tableData = res.data.list.records;
        this.total = res.data.list.total;
      });
    },
    add() {
      this.$refs.dialog.visible = true;
    },
    editData(item) {
      this.$refs.dialog.getInfo(item.id);
    },
    deleteData(item) {
      this.$confirm("确定删除吗？").then(() => {
        this.getAjax("api/delUser", { id: item.id }, "post").then((res) => {
          this.$message.success("删除成功");
          this.initPage();
        });
      });
    },
  },
  mounted() {
    this.initPage();
  },
};
</script>

<style lang="less">
.tianfulove {
  width: 100%;
  height: 100%;
  display: flex;
  .leftBox {
    width: 10%;
min-width:130px;
    height: 100%;
    background: #545c64;
  }
  .rightBox {
    flex: 1;
    padding: 20px;
    .fenye {
      text-align: right;
      padding: 15px 10px;
    }
  }
}
</style>
